import { MapPin, MessageCircle, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { buildStoreWhatsAppUrl, formatStorePhone, getStoreConfig } from "@/lib/storeConfig";

export default function PublicOrderStoreHeader() {
  const store = getStoreConfig();
  const whatsappUrl = buildStoreWhatsAppUrl("Здравствуйте!");
  const formattedPhone = formatStorePhone(store.phone);

  return (
    <header className="border-b border-slate-200/80 bg-white/95 shadow-sm backdrop-blur-sm">
      <div className="mx-auto flex max-w-4xl flex-col gap-4 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
        <div className="flex items-center gap-3">
          {store.logoUrl ? (
            <img
              src={store.logoUrl}
              alt={store.name}
              className="h-11 w-11 rounded-xl object-cover shadow-md"
            />
          ) : (
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 shadow-md">
              <span className="text-lg font-bold text-white">A</span>
            </div>
          )}
          <div>
            <p className="text-lg font-bold tracking-tight text-slate-950" style={{ fontFamily: "Space Grotesk, sans-serif" }}>
              {store.name}
            </p>
            <p className="text-sm text-slate-500">{store.subtitle}</p>
          </div>
        </div>

        <div className="flex flex-col gap-2 sm:items-end sm:text-right">
          <div className="flex items-start gap-2 text-sm text-slate-600 sm:justify-end">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-blue-600" />
            <span>{store.address}</span>
          </div>
          {formattedPhone && (
            <a
              href={`tel:${store.phone.replace(/\s/g, "")}`}
              className="inline-flex items-center gap-2 text-sm font-medium text-slate-800 hover:text-blue-700 sm:justify-end"
            >
              <Phone className="h-4 w-4 text-blue-600" />
              {formattedPhone}
            </a>
          )}
          {whatsappUrl && (
            <Button
              variant="outline"
              size="sm"
              className="w-full border-emerald-200 bg-emerald-50 text-emerald-800 hover:bg-emerald-100 sm:w-auto"
              asChild
            >
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                <MessageCircle className="mr-2 h-4 w-4" />
                Написать в WhatsApp
              </a>
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}
